export default __webpack_public_path__ + "static/media/ZippedFile_Success.b05f22b4.png";